import styled from '@emotion/styled';
import { alpha, Button } from '@mui/material';
import { ButtonLabel } from '@dh/styles';
import { shouldForwardProps } from '@dh/utils';

const FilledButtonWrapper = styled(Button, shouldForwardProps)<{
    isBig?: boolean;
    fullWidth?: boolean;
    themeColor?: string;
}>`
    background-color: ${({ theme, disabled, themeColor }) =>
        disabled
            ? theme.colors.disabled
            : themeColor
              ? alpha(themeColor, 0.8)
              : theme.colors.lightSurfaceTint};
    border-radius: 8px;
    padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(3)}`};
    height: ${({ isBig }) => (isBig ? '56px' : '48px')};
    width: ${({ fullWidth }) => (fullWidth ? '-webkit-fill-available' : 'fit-content')};
    clip-path: inset(-4px);

    &:hover {
        background-color: ${({ theme, themeColor }) =>
            themeColor ? alpha(themeColor, 0.7) : theme.colors.primary30};
    }

    &:focus {
        border: 2px solid ${({ theme }) => theme.colors.white};
        border-radius: 8px;
        box-shadow:
            0 0 0 2px ${({ theme, themeColor }) => themeColor ?? theme.colors.primary},
            0 0 0 4px
                ${({ theme, themeColor }) =>
                    themeColor ? alpha(themeColor, 0.4) : alpha(theme.colors.primary, 0.4)};
    }
`;

const FilledButtonLabel = styled(ButtonLabel, shouldForwardProps)<{
    hasIcon?: boolean;
    isDisabled?: boolean;
}>`
    margin-left: ${({ hasIcon, theme }) => (hasIcon ? theme.spacing(1) : 0)};
    color: ${({ theme, isDisabled }) =>
        isDisabled ? theme.colors.disabledText : theme.colors.white};
`;

export { FilledButtonLabel, FilledButtonWrapper };
